// Export all icon categories
export * from './icons/AppointmentIcons';
export {
  AddOnsIcon,
  AddonsIcon,
  AfternoonIcon,
  AgendaIcon,
  ApplyFeeIcon,
  AppointmentCardIcon,
  BankIcon,
  BankTransferReceivedIcon,
  BookIcon,
  BulkEditIcon,
  AppointmentsIcon as BusinessAppointmentsIcon,
  CoursesIcon as BusinessCoursesIcon,
  CustomersAndPetsIcon as BusinessCustomersAndPetsIcon,
  DashboardIcon as BusinessDashboardIcon,
  HealthConditionIcon as BusinessHealthConditionIcon,
  InvoicesIcon as BusinessInvoicesIcon,
  PawIcon as BusinessPawIcon,
  PhoneIcon as BusinessPhoneIcon,
  ScaleIcon as BusinessScaleIcon,
  ServicesIcon as BusinessServicesIcon,
  TeamMembersIcon as BusinessTeamMembersIcon,
  TutorialsIcon as BusinessTutorialsIcon,
  WarningIcon as BusinessWarningIcon,
  ZoomIcon as BusinessZoomIcon,
  CameraIcon,
  CancelAllAppointmentsIcon,
  CancelAppointmentIcon,
  CancelAppointmentRangeIcon,
  CancelCardIcon,
  CancelSingleAppointmentIcon,
  CapacityIcon,
  CardTapIcon,
  CardTerminalIcon,
  CashIcon,
  ChangeAppointmentIcon,
  ChargeCardIcon,
  ChatBubbleIcon,
  CheckmarkIcon,
  ClipboardIcon,
  CompleteIconSmall,
  CopyIcon,
  CourseIcon,
  CriticalIcon,
  CurrencyIcon,
  CustomRecurringIcon,
  CustomerNotesIcon,
  CustomiseIcon,
  DailyRecurringIcon,
  DayIcon,
  DeclineFilledIcon,
  DeclinedIconSmall,
  DownCircleIcon,
  EveningIcon,
  ExactAppointmentIcon,
  FemaleIcon,
  FocusModeIcon,
  FortnightlyRecurringIcon,
  GoogleMapsIcon,
  HalfFullIcon,
  HardForcedIcon,
  HeartIcon,
  HiddenIcon,
  HideWeekendsIcon,
  InProgressIconSmall,
  InfinityIcon,
  InitialIcon,
  InvoiceIcon,
  LateLevelOneIcon,
  LateLevelTwoIcon,
  LightningIcon,
  MagicIcon,
  MaleIcon,
  ManualReviewIcon,
  MapPinIcon,
  MonthIcon,
  MonthlyRecurringIcon,
  MorningIcon,
  MoveAttendeeIcon,
  MultiDayIcon,
  NextAppointmentIcon,
  PaymentIconSmall,
  PendingIconSmall,
  PeopleIcon,
  PlusIcon,
  PlusMinusIcon,
  PreAuthIcon,
  PreSavedLocationIcon,
  PreviewDocumentIcon,
  PrivateNotesIcon,
  RecurringIcon,
  RecurringPrepaidIcon,
  RedPlaceCircleLocationIcon,
  RefreshIcon,
  RefundIcon,
  RefundIconSmall,
  ResetIcon,
  ResourceIcon,
  ReviewIcon,
  ShowActiveOnlyIcon,
  // Re-export everything else from BusinessIcons
  SmileIcon,
  StackIcon,
  SuccessIcon,
  TimelineIcon,
  TodayIcon,
  TopRightArrowIcon,
  UpCircleIcon,
  VennIcon,
  VideoCallIcon,
  VisibleIcon,
  WaiveFeeIcon,
  WeekIcon,
  WeeklyRecurringIcon,
  WorkflowIcon,
} from './icons/BusinessIcons';
export * from './icons/ContactIcons';
export * from './icons/DashboardIcons';
export * from './icons/HealthIcons';
export * from './icons/MediaIcons';
export * from './icons/NavigationIcons';
export * from './icons/PetIcons';
export * from './icons/StatusIcons';
export * from './icons/UIActionIcons';
